export default __webpack_public_path__ + "static/media/vip-logo-pvip.f21fb813.webp";